import ActiveEllipse from '../../../assets/icons/firm-management/active-ellipse.svg'
import InactiveEllipse from '../../../assets/icons/firm-management/inactive-ellipse.svg'
import { useTranslation } from 'react-i18next'

interface StateCellProps {
  isActive: boolean
}

export const StateCell: React.FC<StateCellProps> = ({ isActive }) => {
  const { t } = useTranslation()

  if (isActive) {
    return (
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
        <ActiveEllipse />
        <span>{t('common.active')}</span>
      </span>
    )
  }

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
      <InactiveEllipse />
      <span>{t('common.inactive')}</span>
    </span>
  )
}
